"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBreakpointActive = void 0;
var _parseMediaQuery = require("./parseMediaQuery");
const isBreakpointActive = (query, viewportWidth) => {
  const parsed = (0, _parseMediaQuery.parseMediaQuery)(query);
  if (!parsed) {
    return false;
  }
  if (parsed.type === 'min-width') {
    return viewportWidth >= parsed.value;
  }
  return viewportWidth <= parsed.value;
};
exports.isBreakpointActive = isBreakpointActive;
